import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LoadingSpinner from "../../loading-spinner/loading-spinner";
import styles from "../../return-to-checkout-modal.module.css";
export var LoadingCard = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: styles.loadingDiv,
        children: /*#__PURE__*/ _jsx(LoadingSpinner, {
            size: 64
        })
    });
};
